import { WeekDayEntryBase, WeekDayEntryUnion } from './WeekDayEntry';
import { parseWeekDayEntryWorkout } from './WeekDayEntryWorkout';
import { parseWeekDayEntryActivityLog } from './WeekDayEntryActivityLog';
import { parseWeekDayEntryEvent } from './WeekDayEntryEvent';
import { parseWeekDayEntrySubscribedEvent } from './WeekDayEntrySubcribedEvent';
import { parseWeekDayEntryMindfulnessUnit } from './WeekDayEntryMindfulnessUnit';

export function buildWeekDayEntry(json?: Partial<WeekDayEntryBase>): WeekDayEntryUnion | undefined {
  switch (json?.type) {
    case 'workout':
      return parseWeekDayEntryWorkout(json as any);
    case 'activityLog':
      return parseWeekDayEntryActivityLog(json as any);
    case 'subscribedEvent':
      return parseWeekDayEntrySubscribedEvent(json as any);
    case 'event':
      return parseWeekDayEntryEvent(json as any);
    case 'mindfulnessUnit':
      return parseWeekDayEntryMindfulnessUnit(json as any);
    case 'activity':
      return undefined;
  }
  return undefined;
}

export const WeekDayEntryBuilder = {
  build: buildWeekDayEntry,
};
